import { Api } from './Api';

export default {
    /*  1. Get all data */
    GetLookUps(body = { keyword: '' }) {
        return Api().post('/LookUp/GetLookUps', body);
    },

    /* 6. Get by keyword*/
    getLookUps(keyword = '') {
        var body = { keyword: keyword }
        return Api().post('/LookUp/GetLookUps', body);
    },


    /*  1. Get all data */
    //getLookUps(keyword = '') {
    //    return Api().get(`/LookUp${keyword ? '?Keyword=' + keyword : ''}`);
    //},

    /*  1. Get all data for main lookup */
    getMainLookups() {
        return Api().get(`/LookUp/GetMainLookups`);
    },

    /*  2. Get one column */
    getLookUp(id) {
        return Api().get(`/Lookup/GetLookupById/${id}`);
    },

    /*  3. Get ctrlId column */
    getLookup(ctrlId) {
        return Api().get(`/Lookup/${ctrlId}`);
    },

    /*  4. Create one column */
    saveLookUp(body) {
        return Api().post(`/Lookup`, body);
    },

    /*  5. Delete one or more columns */
    deleteLookUps(lookUps) {
        return Api().post(`/Lookup/DeleteLookup`, lookUps);
    },

    /*  6. post one or more columns */
    postLookUps(lookUps) {
        return Api().post(`/Lookup/PostLookup`, lookUps);
    },

    getLookupByParentId(parentId, majorId) {
        return Api().get(`/Lookup/GetLookupByParentId?parentId=${parentId}&majorId=${majorId}`);
    },

    getMaxCodeLookup(majorId) {
        return Api().get(`/Lookup/GetMaxCodeLookup?majorId=${majorId}`);
    },

    getMaxOrderIconsLookup(majorId) {
        return Api().get(`/Lookup/GetMaxOrderIconsLookup?majorId=${majorId}`);
    },
    GetCities(governateCode) {
        return Api().get(`/Lookup/GetCities?governateCode=${governateCode}`);
    }
};
